import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import { useEffect } from "react";

const SustainableSolutionWidgetScript: React.FC = () => {

  useEffect(() => {
    // Get all accordion triggers (buttons or anchors)
    const accordionTriggers = document.querySelectorAll('.accordion-trigger');

    accordionTriggers.forEach((trigger, index) => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        handleAccordionClick(index);
      });
    });

    return () => {
      // Cleanup the event listeners on component unmount
      accordionTriggers.forEach((trigger) => {
        trigger.removeEventListener('click', handleAccordionClick);
      });
    };
  }, []);

  const handleAccordionClick = (index: any) => {
    const accordions = document.querySelectorAll('.multiAccordion');

    // Loop through and remove the 'active' class from all except the clicked one
    accordions.forEach((accordion, idx) => {
      if (idx === index) {
        accordion.classList.toggle('active');
      } else {
        accordion.classList.remove('active'); // Ensure others are closed
      }
    });
  };
 
  return null;
};

const sustainableSolutionWidgetScript: WidgetModule = {
    component: SustainableSolutionWidgetScript,
    definition: {
        group: "Basic",
        displayName: "Sustainable Solution Rich Content Script",
    },
};

export default sustainableSolutionWidgetScript;
